import React, {Component} from 'react';
import {message} from "../../../../utils/message";
import {Modal} from "antd";
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";

/**
 * creat by xcc
 * @description 领取阵地
 */
export default class GetPosition extends BaseComponent {
    static propTypes = {
        styleOut: PropTypes.object,
    };
    static defaultProps = {
        styleOut: {},
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    // 领取
    getPosition = (item) => {
        const {clickItem} = this.props;
        clickItem(item);
    }

    render() {
        const {item, styleOut = {}} = this.props;
        return (
            <>
                <span style={{cursor: "pointer", ...styleOut}} onClick={() => this.getPosition(item)}>领取账号</span>
            </>
        )
    }

}